import { createApi } from '@core/fetch'

export default {
  yearReviewStatus: createApi(
    '/p/wedding/index.php/admin/APIWcdActivity/yearReviewStatus'
  ),
  closeYearReview: createApi.post(
    '/p/wedding/index.php/admin/APIWcdActivity/closeYearReview'
  ),
  materialList: createApi(
    '/hms/hljActivity/adminApi/annual/merchant/material/list'
  ),
  submitMaterial: createApi.post(
    '/hms/hljActivity/adminApi/annual/merchant/post/material'
  )
}
